<template>
  <div id="addReportTaskContainer">
    <form id="templateAddForm">
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">
                <span class="h-red-code">*</span>
                {{$t('Pm.reportTask.name')}}:
              </div>
              <input
                name="name"
                :placeholder="$t('Pm.placeholder.name')"
                v-model="pmGnbReportTask.name"
                class="e-input e-input-group"
                maxlength="20"
              />
              <div class="error"></div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">
                <span class="h-red-code">*</span>
                {{$t('Pm.reportTask.format')}}:
              </div>
              <ejs-dropdownlist
                :dataSource="formatList"
                v-model="pmGnbReportTask.format"
                name="format"
                :fields="fieldsFormat"
                @change="formatChange"
              ></ejs-dropdownlist>
              <div class="error"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">
                <span class="h-red-code">*</span>
                {{$t('Pm.reportTask.exeCycle')}}:
              </div>
              <ejs-dropdownlist
                :dataSource="exeCycleList"
                v-model="pmGnbReportTask.exeCycle"
                name="exeCycle"
                :fields="fieldsOfExeCycle"
                @change="exeCycleChange"
              ></ejs-dropdownlist>
            </div>
            <div class="error"></div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input" v-if="exeCycleFlag">
              <div class="h-inputLit">{{$t('Pm.reportTask.exeStep')}}:</div>
              <input
                name="exeStep"
                :placeholder="$t('Pm.placeholder.exeStep')"
                v-model="pmGnbReportTask.exeStep"
                class="e-input e-input-group"
                maxlength="20"
              />
            </div>
            <div class="error"></div>
          </div>
        </div>
      </div>
     </form>

      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Pm.reportTask.startTime')}}:</div>
              <ejs-datepicker
                :format="dateFormat"
                v-model="pmGnbReportTask.startTime"
                ref="startTime"
                class="e-input"
                :allowEdit="false"
                @keydown.native="stopEvent"
                :locale="locale"
              ></ejs-datepicker>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Pm.reportTask.endTime')}}:</div>
              <ejs-datepicker
                :format="dateFormat"
                v-model="pmGnbReportTask.endTime"
                :min="pmGnbReportTask.startTime"
                ref="endTime"
                class="e-input"
                :allowEdit="false"
                @keydown.native="stopEvent"
                :locale="locale"
              ></ejs-datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="form-group h-col-inputBox">
          <div class="e-float-input">
            <ejs-grid
              :dataSource="reportTemplateData"
              :allowPaging="true"
              ref="grid"
              :pageSettings="pageSettings"
              height="240"
              :allowExcelExport="true"
              :rowSelected='onRowSelected'
            >
              <e-columns>
                <e-column field="templateId" :visible="false"></e-column>
                <e-column field="templateName" :headerText="$t('Pm.templateName')" width="25%" clipMode="EllipsisWithTooltip" textAlign="Center"></e-column>
                <e-column field="neTypeName" :headerText="$t('Pm.neType')" width="10%" clipMode="EllipsisWithTooltip" textAlign="Center"></e-column>
                <e-column field="paramTypeName" :headerText="$t('Pm.reportTask.parameterType')" width="10%" clipMode="EllipsisWithTooltip" textAlign="Center"></e-column>
                <e-column field="spaceName" :headerText="$t('Pm.reportTask.space')" width="10%" clipMode="EllipsisWithTooltip" textAlign="Center"></e-column>
              </e-columns>
            </ejs-grid>
            <ejs-pager
              ref="pagerForTemplate"
              :pageSize="pageSettings.pageSize"
              :pageCount="pageSettings.pageCount"
              :currentPage="pageSettings.currentPage"
              :totalRecordsCount="pageSettings.totalRecordsCount"
              @click="getReportTemplateList"
            ></ejs-pager>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input" id="customsBox">
              <div class="h-inputLit">
                <span class="h-red-code">*</span>
                {{$t('Pm.systemCounterList')}}:
              </div>
              <div v-for="(alarm, index) in counterListShow" :key="index" class="col-sm-8 nopadding">
                <ejs-checkbox
                  ref="customsCheckbox"
                  :label="alarm.text"
                  :value="alarm.value"
                  :checked="alarm.checked"
                  disabled="true"
                ></ejs-checkbox>
              </div>
              <div class="error"></div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input" id="customCounterBox">
              <div class="h-inputLit">
                <span class="h-red-code">*</span>
                {{$t('Pm.customCounterList')}}:
              </div>
              <div v-for="(alarm, index) in customCounterListShow" :key="index" class="col-sm-8 nopadding">
                <ejs-checkbox
                  ref="customsCheckbox"
                  :label="alarm.text"
                  :value="alarm.value"
                  :checked="alarm.checked"
                  disabled="true"
                ></ejs-checkbox>
              </div>
              <div class="error"></div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { CheckBoxSelection } from "@syncfusion/ej2-vue-dropdowns";
import { FormValidator } from "@syncfusion/ej2-vue-inputs";
import {EventBus} from "../../../../plugins/eventBus";

export default {
  name: "TemplateAddTask",
  components: {},
  data() {
    return {
      selectedData:{},
      reportTemplateData: [],
      pageSettings: {
        pageSize: 15,
        pageCount: 4,
        currentPage: 1,
        totalRecordsCount: 0
      },
      formValidator: "",
      dateFormat: "yyyy-MM-dd",
      locale: localStorage.getItem("locale"),
      exeCycleFlag: false,
      counterListShow: [],
      customCounterListShow: [],
      pmGnbReportTask: {
        id: "",
        name: "",
        format: "",
        exeCycle: "",
        exeStep: "",
        startTime: "",
        endTime: "",
      },
      fieldsFormat: {
        text: "text",
        value: "value"
      },
      fieldsOfExeCycle: {
        text: "text",
        value: "value"
      },
      exeCycleList: [
        { text: `${this.$t("Pm.reportTask.hours")}`, value: 1 },
        { text: `${this.$t("Pm.reportTask.days")}`, value: 2 },
        { text: `${this.$t("Pm.reportTask.weeks")}`, value: 3 },
        { text: `${this.$t("Pm.reportTask.months")}`, value: 4 },
        { text: `${this.$t("Pm.reportTask.fixedDays")}`, value: 5 }
      ],
      formatList: [
        { text: "csv", value: "csv" },
        { text: "excel", value: "excel" }
      ],
      validateOptions: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'fixed';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          name: {
            required: [true, `${this.$t("Pm.placeholder.name")}`],
            maxLength: [20, `${this.$t("Common.maxLength")}`.replace("{0}", 20)]
          },
          format: {
            required: [true, `${this.$t("Pm.placeholder.format")}`]
          },
          exeCycle: {
            required: [true, `${this.$t("Pm.placeholder.exeCycle")}`]
          },
          exeStep: {
            regex:  ["^\\d*$", `${this.$t("Topo.invalidInt")}`]
          },
        }
      }
    };
  },
  methods: {
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.no_checked")}`
        });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.too_many_checked")}!`
        });
        return false;
      }
      return selectedRecords;
    },
    onRowSelected(args) {
      const counters=JSON.parse(args.data.counterList);
      const customCounters=JSON.parse(args.data.customCounterList);

      this.selectedData=args.data;
      this.counterListShow = [];
      for(var key in counters){
        if (counters.hasOwnProperty(key)) {
          this.counterListShow.push({
            text: counters[key],
            value: key + '-' + counters[key],
          });
        }
      }

      this.customCounterListShow = [];
      for(var key in customCounters){
        if (customCounters.hasOwnProperty(key)) {
          this.customCounterListShow.push({
            text: customCounters[key],
            value: key + '-' + customCounters[key],
          });
        }
      }
    },
    getReportTemplateList() {
      const This = this;
      This.pageSettings.currentPage =
        This.$refs.pagerForTemplate.ej2Instances.currentPage;
      this.axios
        .post("/lte/ems/pm/gnb/report/template/getReportTemplateList.html", {
          page: {
            pageNo: This.pageSettings.currentPage,
            pageSize: This.pageSettings.pageSize
          }
        })
        .then(response => {
          const result = response.data.resultVal;
          This.pageSettings.totalRecordsCount = result.totalCount;
          This.pageSettings.currentPage = result.pageNo;
          This.reportTemplateData = result.result;
        });
    },

    init() {
      this.formValidator = new FormValidator(
        "#templateAddForm",
        this.validateOptions
      );
    },
    exeCycleChange(msg) {
      this.pmGnbReportTask.exeCycle = msg.value;
      if (msg.value == "5") {
        this.exeCycleFlag = true;
        this.formValidator.addRules("exeStep", {regex: ["^\\d*$", `${this.$t("Topo.invalidInt")}`]});
      } else {
        this.exeCycleFlag = false;
        this.formValidator.removeRules("exeStep");
      }
    },
    formatChange(msg) {
      this.pmGnbReportTask.format = msg.value;
    },
    getReportTask() {
      return {
        name: this.pmGnbReportTask.name,
        format: this.pmGnbReportTask.format,
        exeCycle: this.pmGnbReportTask.exeCycle,
        exeStep: this.pmGnbReportTask.exeStep,
        startTime: new Date(this.pmGnbReportTask.startTime).getTime(),
        endTime: new Date(this.pmGnbReportTask.endTime).getTime(),
        neType: this.selectedData.neTypeCode+"-"+this.selectedData.neTypeVersion,
        parameterType: this.selectedData.paramTypeCode+"-"+this.selectedData.paramTypeName,
        space: this.selectedData.spaceCode+"-"+this.selectedData.spaceName,
        counterList: this.selectedData.counterList,
        customCounterList: this.selectedData.customCounterList
      };
    },
    getArray(id) {
      const checkedDom = document.querySelectorAll(
        `#${id} [aria-checked=true] input`
      );
      const array = [];
      for (let i = 0; i < checkedDom.length; i++) {
        array.push(checkedDom[i].value);
      }
      return array;
    },
    templateValidation() {
        const status = this.formValidator.validate();
        return status;
    },
    stopEvent(event) {
      if (event.keyCode == 13) {
        event.cancelBubble = true;
        event.returnValue = false;
        return false;
      }
    },
  },
  mounted() {
    this.init();
    this.getReportTemplateList();
  }
};
</script>
